import { teacherServiceURL } from '../endpoint';

export function salesUrl() {
  const url = new URL(teacherServiceURL);
  url.pathname += 'sales';
  return url;
}

export function createCheckoutSessionUrl() {
  const url = salesUrl();
  url.pathname += '/create-checkout-session';
  return url;
}

export function createCustomerPortalSessionUrl() {
  const url = salesUrl();
  url.pathname += '/create-customer-portal-session';
  return url;
}
export function subscriptionPlansUrl() {
  const url = salesUrl();
  url.pathname += '/subscription-plans';
  return url;
}
